import React from "react";
import { Select, MenuItem, SelectChangeEvent } from "@mui/material";

interface HeaderSelectProps<T extends string | number> {
  value: T;
  onChange: (event: SelectChangeEvent<T>, child: React.ReactNode) => void;
  options: T[];
  labels: Record<T, string>;
  className?: string;
}

export const HeaderSelect = (props: HeaderSelectProps<string | number>) => {
  const { value, onChange, options, labels, className } = props;
  return (
    <Select
      className={className}
      variant="outlined"
      size="small"
      fullWidth
      value={value}
      onChange={onChange}
      displayEmpty
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      }}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {labels[option]}
        </MenuItem>
      ))}
    </Select>
  );
};
